/* Most do koszyka Horizona 4.1.1 dla własnych ścieżek zakupowych (2026-09-12):
   konfigurator próbek (konfigurator-probek.js) i drawer zakupu na kartach stylów
   (knf-karta-zakup.js). Ten sam kontrakt co blok "DODAWANIE DO KOSZYKA" w
   konfigurator-natywny.js, który celowo zostaje samodzielny (świeżo wdrożony, testowany).
   Po udanym /cart/add.js: natywne zdarzenie shopify:cart:lines-update (szuflada przez
   cart-drawer.js, zawartość przez component-cart-items.js, licznik przez cart-icon.js),
   bez ręcznego innerHTML, bez showModal(), bez martwych cart:refresh.
   Ładowany jako klasyczny <script defer> PRZED skryptem ścieżki. API: window.knfCart. */
(function () {
  "use strict";
  if (window.knfCart) return;

  const CART_ROOT = window.Shopify?.routes?.root || "/";
  const EVENT_NAME = "shopify:cart:lines-update";
  const SECTION_ID = (() => {
    const sec = document.querySelector("cart-drawer-component")?.closest(".shopify-section");
    return sec ? sec.id.replace(/^shopify-section-/, "") : "cart-drawer-section";
  })();
  let ctorPromise = null;
  const sleep = (ms) => new Promise(rs => setTimeout(rs, ms));

  // /cart.js z limitem czasu. Nigdy nie blokuje ścieżki sukcesu (null = nie wiadomo).
  async function fetchCartSafe(timeoutMs) {
    const ctrl = typeof AbortController === "function" ? new AbortController() : null;
    const timer = setTimeout(() => { if (ctrl) ctrl.abort(); }, timeoutMs || 2500);
    try {
      const r = await fetch(`${CART_ROOT}cart.js`, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: "application/json" }, cache: "no-store" });
      if (!r.ok) return null;
      return await r.json();
    } catch (_) {
      return null;
    } finally {
      clearTimeout(timer);
    }
  }

  // Tożsamość linii jak w Shopify: wariant + widoczne properties (bez prefiksu "_"). Bez ilości.
  function hashParts(variantId, entries) {
    const props = entries
      .filter(([k, v]) => !k.startsWith("_") && String(v ?? "").trim() !== "")
      .map(([k, v]) => `${k}=${String(v).trim()}`)
      .sort();
    return `${String(variantId)}|${props.join("")}`;
  }
  function buildConfigHash(formData) {
    const entries = [];
    for (const [key, value] of formData.entries()) {
      const m = /^properties\[(.+)\]$/.exec(key);
      if (m) entries.push([m[1], value]);
    }
    return hashParts(formData.get("id"), entries);
  }
  function findLineByHash(cart, hash) {
    const items = (cart && Array.isArray(cart.items)) ? cart.items : [];
    for (const it of items) {
      if (hashParts(it.variant_id ?? it.id, Object.entries(it.properties || {})) === hash) {
        return { key: it.key, quantity: it.quantity || 0 };
      }
    }
    return null;
  }

  // Klasa zdarzenia z magistrali Horizona (import mapa obowiązuje też dla import() ze skryptu
  // klasycznego). Fallback: Event o tym samym kształcie.
  class KnfCartLinesUpdateEvent extends Event {
    constructor(payload) {
      super(EVENT_NAME, { bubbles: true, cancelable: true, composed: true });
      Object.assign(this, payload);
    }
  }
  function createDeferred() {
    let resolve, reject;
    const promise = new Promise((rs, rj) => { resolve = rs; reject = rj; });
    return { promise, resolve, reject };
  }
  function getCtor() {
    if (!ctorPromise) {
      ctorPromise = import("@shopify/events")
        .then(mod => (mod && typeof mod.CartLinesUpdateEvent === "function") ? mod.CartLinesUpdateEvent : null)
        .catch(err => { console.warn("[knfCart] @shopify/events niedostępne, zdarzenie fallback", err); return null; });
    }
    return ctorPromise;
  }
  function summaryFromAjax(cart) {
    const money = (cents) => ({ amount: (Number(cents || 0) / 100).toFixed(2), currencyCode: cart.currency || "" });
    return {
      id: cart.token || "",
      totalQuantity: cart.item_count || 0,
      cost: { totalAmount: money(cart.total_price) },
      lines: (cart.items || []).map(it => ({ id: it.key, quantity: it.quantity, cost: { totalAmount: money(it.final_line_price) } })),
      discountCodes: (cart.discount_codes || []).map(d => ({ code: d.code, applicable: !!d.applicable })),
    };
  }
  // Emisja PO sukcesie /cart/add.js (cart-drawer.js otwiera szufladę optymistycznie przy dispatchu).
  // target: element poza cart-items-component i poza dialog:modal.
  async function emitLinesUpdate(target, variantId, qty) {
    const Ctor = await getCtor();
    const deferred = (Ctor && typeof Ctor.createPromise === "function") ? Ctor.createPromise() : createDeferred();
    const payload = { action: "add", context: "product", lines: [{ merchandiseId: String(variantId), quantity: qty }], promise: deferred.promise };
    (target || document.body).dispatchEvent(Ctor ? new Ctor(payload) : new KnfCartLinesUpdateEvent(payload));
    return { deferred, Ctor };
  }
  function resolveUpdate({ deferred, Ctor }, { cart, sections, itemCount }) {
    let summary = null;
    if (cart) {
      try { summary = (Ctor && typeof Ctor.createCartFromAjaxResponse === "function") ? Ctor.createCartFromAjaxResponse(cart) : summaryFromAjax(cart); }
      catch (_) { summary = summaryFromAjax(cart); }
    }
    deferred.resolve({
      cart: summary,
      detail: { sections: sections || undefined, itemCount, items: cart ? cart.items : [], didError: false, source: "knf-cart-bridge" },
    });
  }
  function readHeaderCount() {
    const icon = document.querySelector("cart-icon");
    if (icon && Number.isFinite(icon.currentCartCount)) return icon.currentCartCount;
    const n = parseInt(document.querySelector('[ref="cartBubbleCount"]')?.textContent || "", 10);
    return Number.isFinite(n) ? n : 0;
  }

  // Szuflada: czekamy na definicję <theme-drawer> (moduł z fetchpriority=low). Bez showModal().
  async function ensureDrawerOpen(timeoutMs) {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer) return false;
    if (drawer.hasAttribute("open")) return true;
    if (!window.customElements) return false;
    const defined = await Promise.race([
      customElements.whenDefined("theme-drawer").then(() => true),
      sleep(timeoutMs || 2500).then(() => false),
    ]);
    if (!defined) { console.warn("[knfCart] theme-drawer nie zdefiniowany, szuflada bez auto-open"); return false; }
    await sleep(60);
    if (drawer.hasAttribute("open") || drawer.isOpen) return true;
    if (typeof drawer.open === "function") { drawer.open(); return true; }
    return false;
  }
  // Tylko gdy komponenty koszyka nie są jeszcze zdefiniowane (zdarzenie trafiłoby w próżnię).
  function applyDrawerHtmlFallback(html, itemCount) {
    try {
      if (html && !customElements.get("cart-items-component")) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const fresh = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
        const cur = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
        if (fresh && cur) cur.replaceWith(document.adoptNode(fresh));
      }
      if (!customElements.get("cart-icon")) {
        const bubble = document.querySelector('[ref="cartBubble"]');
        const count = document.querySelector('[ref="cartBubbleCount"]');
        if (count) { count.textContent = itemCount < 100 ? String(itemCount) : ""; count.classList.toggle("hidden", itemCount === 0); }
        if (bubble) bubble.classList.toggle("visually-hidden", itemCount === 0);
      }
    } catch (err) {
      console.warn("[knfCart] fallback szuflady", err);
    }
  }

  // Pełny cykl po udanym /cart/add.js: zdarzenie dla motywu (od razu, z sekcją z odpowiedzi
  // add.js), szuflada, korekta licznika z /cart.js. Nigdy nie rzuca; zwraca /cart.js albo null.
  async function afterAdd(target, { variantId, qty, sections }) {
    let cart = null;
    try {
      const itemCount = readHeaderCount() + (qty || 1);
      const ev = await emitLinesUpdate(target, variantId, qty || 1);
      resolveUpdate(ev, { cart: null, sections, itemCount });
      applyDrawerHtmlFallback(sections ? sections[SECTION_ID] : null, itemCount);
      const drawerP = ensureDrawerOpen(2500);
      cart = await fetchCartSafe(2500);
      if (cart && cart.item_count !== itemCount) {
        const icon = document.querySelector("cart-icon");
        if (icon && typeof icon.renderCartBubble === "function") icon.renderCartBubble(cart.item_count, false);
      }
      await drawerP;
    } catch (err) {
      console.warn("[knfCart] po dodaniu (nieblokujące)", err);
    }
    return cart;
  }

  window.knfCart = { root: CART_ROOT, sectionId: SECTION_ID, fetchCartSafe, buildConfigHash, findLineByHash, emitLinesUpdate, resolveUpdate, ensureDrawerOpen, afterAdd };
  getCtor(); // rozgrzewka importu, żeby pierwsze dodanie nie czekało na moduł
})();
